module.exports = __webpack_public_path__ + "carousel-control-da20ce98f5a7142278924703bf9b1a84.svg";


//////////////////
// WEBPACK FOOTER
// ./app/assets/images/svg/carousel-control.svg
// module id = 2637
// module chunks = 6